import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { userOnBoarding } from "store/services/Profile/profile";
import { showToast } from "utils/showToast";

const OnBoarding = () => {
  const navigate = useNavigate();
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);
  const { familyMemberss } = useSelector((store) => store.userProfile);
  const [familyMembers, setFamilyMembers] = useState({
    zeroToTwo: 0,
    threeToFive: 0,
    sixToTwelve: 0,
    teenagers: 0,
    extendedFamily: 0,
    pets: 0,
    postTeenagers: 0,
  });

  const handleUpdate = (key, value) => {
    setFamilyMembers((prevState) => ({
      ...prevState,
      [key]: value < 0 ? 0 : value,
    }));
  };

  const AgeList = ({ age, number, ageKey }) => {
    const handleDecrement = () => {
      handleUpdate(ageKey, familyMembers[ageKey] - 1);
    };

    const handleIncrement = () => {
      handleUpdate(ageKey, familyMembers[ageKey] + 1);
    };

    return (
      <div className="flex justify-between m-4 ">
        <div>{age}</div>
        <div className="flex items-center gap-3 font-bold">
          <div className={`${number === 0 ? "hidden" : ""}`}>
            <FaMinus
              onClick={handleDecrement}
              style={{
                color: selectedStore?.theme.color,
              }}
              className="text-theme-color"
            />
          </div>
          <div className="flex items-center justify-center w-6 ml-auto mr-auto ">
            {number}
          </div>
          <div>
            <FaPlus
              style={{
                color: selectedStore?.theme.color,
              }}
              onClick={handleIncrement}
              className="text-theme-color"
            />
          </div>
        </div>
      </div>
    );
  };
  const HandleSubmitButton = async () => {
    const data = {
      myself: familyMemberss.married || familyMembers.single ? true : true,
      spouse: familyMemberss.married ? true : false,
      kids_0_2: familyMembers.zeroToTwo,
      kids_3_5: familyMembers.threeToFive,
      kids_6_12: familyMembers.sixToTwelve,
      kids_teens: familyMembers.teenagers,
      kids_post_teens: familyMembers.postTeenagers,
      extended_family: familyMembers.extendedFamily,
      pets: familyMembers.pets,
    };
    const onBoarding = await userOnBoarding(
      user.accessToken,
      user.data.id,
      data
    );
    if (onBoarding.success) {
      showToast(onBoarding.data, "success", true);
      navigate(`/stores/${selectedStore?.id}/dashboard`);
    }
  };
  return (
    <div className="flex flex-col justify-center flex-grow min-h-screen align-center gap-7">
      <div className="mt-4 text-3xl text-center">
        <h3>How many family members in total?</h3>
      </div>
      <div className="p-8 ml-auto mr-auto bg-gray-100 rounded-lg shadow-lg lg:w-1/3 h-96">
        <AgeList
          ageKey={"zeroToTwo"}
          age={"0 - 2 years"}
          number={familyMembers.zeroToTwo}
        />
        <AgeList
          ageKey={"threeToFive"}
          age={"3 - 5 years"}
          number={familyMembers.threeToFive}
        />
        <AgeList
          ageKey={"sixToTwelve"}
          age={"6 - 12 years"}
          number={familyMembers.sixToTwelve}
        />
        <AgeList
          ageKey={"teenagers"}
          age={"Teenagers"}
          number={familyMembers.teenagers}
        />
        <AgeList
          ageKey={"postTeenagers"}
          age={"Post-Teens"}
          number={familyMembers.postTeenagers}
        />
        <AgeList
          ageKey={"extendedFamily"}
          age={"Extended Family"}
          number={familyMembers.extendedFamily}
        />
        <AgeList ageKey={"pets"} age={"Pets"} number={familyMembers.pets} />
      </div>
      <div className="flex flex-col items-center justify-center gap-2 ">
        <div>
          Total Family Members :
          {Object.values(familyMembers).reduce((acc, val) => acc + val)}
        </div>
        <div className="flex gap-4">
          <div>
            <button
              style={{
                backgroundColor: selectedStore?.theme.backgroundColor,
              }}
              onClick={HandleSubmitButton}
              className="w-24 px-3 py-1 text-white rounded-md bg-theme-color hover:bg-lighterPurple"
            >
              Proceed
            </button>
          </div>
          <div>
            <button
              style={{
                backgroundColor: selectedStore?.theme.backgroundColor,
              }}
              onClick={() => navigate(`/stores/${selectedStore.id}/dashboard`)}
              className="w-24 px-3 py-1 text-white rounded-md bg-theme-color hover:bg-lighterPurple"
            >
              Skip
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnBoarding;
